import { render, staticRenderFns } from "./txt-quarternary.vue?vue&type=template&id=0a6d5046&scoped=true&"
import script from "./txt-quarternary.vue?vue&type=script&lang=js&"
export * from "./txt-quarternary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6d5046",
  null
  
)

export default component.exports